import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import YandexShare from 'react-yandex-share';

import styles from './styles.module.scss';

const ShareButtons = ({
	theme,
	customSocialButtonsOrder = 'vkontakte,odnoklassniki,whatsapp,telegram',
	customClassName = '',
	imageSrc
}) => {
	const shareButtonsCx = cx(
		styles.wrap,
		styles[`theme_${theme}`],
		styles[customClassName]
	);

	return (
		<div className={shareButtonsCx}>
			<YandexShare
				key={imageSrc}
				theme={{
					bare: true,
					lang: 'ru',
					services: customSocialButtonsOrder
				}}
				content={
					!!imageSrc && {
						url: imageSrc
					}
				}
			/>
		</div>
	);
};

ShareButtons.propTypes = {
	theme: PropTypes.oneOf(['horizontal']),
	customSocialButtonsOrder: PropTypes.string,
	customClassName: PropTypes.string,
	imageSrc: PropTypes.string
};

export default ShareButtons;
